import { NgModule } from '@angular/core';
import { ValidationErrorsComponent } from './validation-errors.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';

@NgModule({
    declarations: [ValidationErrorsComponent],
    imports     : [ CommonModule, PhoenixPipesModule, PhoenixDirectivesModule],
    exports     : [ValidationErrorsComponent],
    providers   : [],
})
export class ValidationErrorsModule {}
